import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  config!: IConfig;

  constructor(private httpClient: HttpClient) { }

  initialize(): Observable<any> {
    const cacheBuster = Math.random();

    // const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.httpClient.get<IConfig>(`appConfig.json?${cacheBuster}`)
      .pipe(tap((config: IConfig) => this.config = config))
  }  
}

export interface IConfig {
  apiBaseUrl: string;
  selectUrl: string;
  version: string;
}
